import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Chip,
    Card,
    Link,
    TableContainer,
    Paper,
    Typography,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Tooltip,
    Box
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../../utils';
import { showSnackbar } from '../../../redux/snackbar/actions';
import moment from 'moment';
import subscriptionApi from '../../../services/subscribe';
import getbusinessuuidApi from '../../../services/managelicense';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../../redux/loader/actions';
import CustomDatagrid from '../../../components/datagrid';
import PriceDetails from '../price_modal';
import DownloadIcon from '@mui/icons-material/Download';
import { setExpiryItems, clearExpiryItems } from '../../../redux/expiry/actions';
import CloseIcon from '@mui/icons-material/Close';
function OrdersList({
    searchParams,
    setSearchParams,
    getSubscriptionData,
    subscriptionData,
    paginationModelSub,
    setPaginationModelSub,
    rowCountSub
}) {
    const { action, businessuuid, productid, planid, subscription_uuid, productPlanDetails, puser } = useParams();
    const userIds = getDecryptedCookie('puser');

    useEffect(() => {
        if (userIds === puser && action === 'renew') {
            handleRenewMail(action, businessuuid, productid, planid, subscription_uuid);
        }
    }, [action]);

    const menuItems = useSelector((state) => state.menuReducer.items);
    const createMenuItem = menuItems?.find((item) => item.name.toLowerCase() === 'subscriptions');
    const isDisabled = createMenuItem?.access_type === 'read_write';
    const organizationItems = useSelector((state) => state.organizationReducer.items);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userId = getDecryptedCookie('uuid');
    const [openPriceDetailsModal, setOpenPriceDetailsModal] = useState(false);
    const [filteredPlans, setFilteredPlans] = useState([]);
    const [productDetails, setProductDetails] = useState([]);
    const [planId, setPlanId] = useState();
    const [renewPlan, setRenewPlan] = useState();
    const [renewPlanOff, setRenewPlanOff] = useState();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRows, setSelectedRows] = useState(null);
    const [planData, setPlanData] = useState({
        productName: '',
        plan: ''
    });
    const [busUUID, setBusUUID] = useState();
    const [selectedPlanDetails, setSelectedPlanDetails] = useState();
    const [openSubscribeDialog, setOpenSubscribeDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [renewData, setRenewData] = useState();

    const handleOpenDialog = (row) => {
        setSelectedRows(row);
        setOpenDialog(true);
        setRenewData(row);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedRows(null);
    };
    useEffect(() => {
        removeCookie('proid');
        removeCookie('upid');
        removeCookie('action');
        removeCookie('upgrade');
        removeCookie('type');
    }, []);

    const handleYes = () => {
        if (selectedRow) {
            handleGrade(
                selectedRow?.find_id,
                selectedRow?.prodId,
                selectedRow?.busId,
                selectedRow?.subscriptionType,
                selectedRow?.cancel_id
            );
            removeCookie('bup');
        }
        setOpenSubscribeDialog(false);
    };

    const handleSubscribe = (row) => {
        setSelectedRow(row);
        setOpenSubscribeDialog(true);
    };
    const handleDialogClose = () => {
        setOpenSubscribeDialog(false);
    };
    const handleNo = () => {
        dispatch(showLoader());
        handleGrade(
            selectedRow?.find_id,
            selectedRow?.prodId,
            selectedRow?.busId,
            selectedRow?.subscriptionType,
            selectedRow?.cancel_id
        );

        setEncryptedCookie('bup', 'del', {
            expires: 7
        });
        setOpenSubscribeDialog(false);
    };
    const handleGrade = (upid, uuid, busid, type, s_uuid) => {
        let types = type === 'Subscription' ? 'upgrade' : 'trials';
        let action = type === 'Subscription' ? 'upgrade' : 'trials';
        removeCookie('proid');
        removeCookie('upid');
        action = action.toLowerCase();
        if (action === 'upgrade' || action === 'trials') {
            navigate(`/products/plan`);
        }
        setEncryptedCookie('proid', uuid, {
            expires: 7
        });
        setEncryptedCookie('suuid', s_uuid, {
            expires: 7
        });
        setEncryptedCookie('action', action, {
            expires: 7
        });
        setEncryptedCookie('upid', upid, {
            expires: 7
        });
        setEncryptedCookie('upgrade', busid, {
            expires: 7
        });
        setEncryptedCookie('type', types, {
            expires: 7
        });
    };
    const [subUUID, setSubUUID] = useState();

    const handleRenewMail = (action, busid, uuid, planid, sub_uuid) => {
        setOpenPriceDetailsModal(true);
        getPlanDetails(uuid);
        setBusUUID(busid);
        setPlanId(planid);
        setPlanData({ plan: planid });
        setSubUUID(sub_uuid);
        setEncryptedCookie('upgrade', busid);
        setEncryptedCookie('proid', uuid, {
            expires: 7
        });
        setEncryptedCookie('puuid', uuid);
        setEncryptedCookie('suuid', sub_uuid);
    };

    const handleRenew = (action, busid, uuid, planid, productName, plan, sub_uuid, renew) => {
        removeCookie('proid');
        setOpenPriceDetailsModal(true);
        getPlanDetails(uuid);
        setBusUUID(busid);
        setPlanId(planid);
        setPlanData({ productName: productName, plan: plan });
        setSubUUID(sub_uuid);
        setEncryptedCookie('upgrade', busid);
        setEncryptedCookie('proid', uuid, {
            expires: 7
        });
        setEncryptedCookie('puuid', uuid);
        setEncryptedCookie('suuid', sub_uuid);
        setSelectedPlanDetails(renew);
    };
    const handleCancel = (id) => {
        cancelSubscription(id);
    };

    const cancelSubscription = useCallback((id) => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res?.data?.status) {
                dispatch(
                    showSnackbar({
                        message: res?.data?.msg,
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        variant: 'success'
                    })
                );
                getSubscriptionData(userId);
            }
        };
        const onFailure = (err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: err?.response?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'error'
                })
            );
        };
        subscriptionApi?.cancelSubscription(id).then(onSuccess, onFailure);
    }, []);

    const getPlanDetails = (productUUID) => {
        dispatch(showLoader());
        subscriptionApi
            .getPlanFeatures(productUUID)
            .then((res) => {
                dispatch(hideLoader());
                setFilteredPlans(res.data.data);
                setRenewPlanOff(res.data.package);
                setProductDetails(res.data.product);
            })
            .catch((err) => {
                dispatch(hideLoader());
                console.error('Error response:', err);
            });
    };
    useEffect(() => {
        if (planId && filteredPlans.length > 0) {
            const plan = filteredPlans.find((plan) => plan?.product_plan_uuid === planId);
            if (plan) {
                setRenewPlan(plan);
            } else {
                console.log('Plan not found with planId:', planId);
            }
        }
    }, [filteredPlans, planId]);

    const clientListRows = Array.isArray(subscriptionData?.data)
        ? subscriptionData.data.map((data, index) => {
              const expiryDate = moment(data?.expiry_date);
              const currentDate = moment();
              const isActive = currentDate.isBefore(expiryDate);
              const sno_id = paginationModelSub.page * paginationModelSub.pageSize + (index + 1);
              return {
                  cancel_id: data?.subscription_uuid,
                  proId: data?.productPlanDetails?.product?.uuid,
                  busId: data?.businessDetailsFromSubscription?.business_uuid,
                  find_id: data?.business_id,
                  prodId: data?.productPlanDetails?.product?.uuid,
                  planId: data?.productPlanDetails?.product_plan_uuid,
                  plan: data?.productPlanDetails?.product_plan_name,
                  id: index + 1,
                  sno_id: sno_id,
                  productName: data?.productPlanDetails?.product?.name || 'N/A',
                  businessName: data?.businessDetailsFromSubscription?.business_name || 'N/A',
                  subscriptionID: data?.subscription_code || 'N/A',
                  subscriptionPlan: data?.productPlanDetails?.product_plan_name || 'N/A',
                  purchasedOn: data?.paymentReceipt?.payment_date,
                  expiry: data?.expiry_date,
                  status: data?.subscription_status,
                  subscriptionType: data?.subscription_type.charAt(0).toUpperCase() + data?.subscription_type.slice(1),
                  renew: data?.productPlanDetails,
                  is_renewed: data?.is_renewed,
                  cancelled: data?.is_cancelled,
                  businessId: data?.businessDetailsFromSubscription?.business_code,
                  invoiceNumber: data?.paymentReceipt?.invoice?.invoice_no,
                  trial: data?.is_trial_subscribed
              };
          })
        : [];
    useEffect(() => {
        dispatch(clearExpiryItems());
    }, []);
    const handleConfig = (row) => {
        navigate(`/subscriptions/manageproducts/productconfig/${row?.prodId}/${row?.busId}`);
        getbusinessuuid(row?.prodId, row?.busId);
        setEncryptedCookie('buslap', row?.busId);
        setEncryptedCookie('proid', row?.prodId);

        if (row.status === 'expired') {
            const expiredData = {
                action: 'renew',
                busId: row.busId,
                proId: row.prodId,
                planId: row.planId,
                product: row.productName,
                plan: row.plan,
                subuuid: row.cancel_id,
                renewDetails: row.renew,
                bid: row.bid
            };
            dispatch(setExpiryItems(expiredData));
        }
    };

    const getbusinessuuid = useCallback((proid, business_uuid) => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res.data.status) {
                setEncryptedCookie('bss', res?.data?.data?.data[0]?.business_uuid);
            }
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch data', err);
        };

        getbusinessuuidApi.getbusinessId(proid, business_uuid).then(onSuccess).catch(onFailure);
    }, []);

    const handlePdf = (id, invoiceNumber) => {
        subscriptionApi
            ?.getInvoice(id)
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const formattedInvoiceNumber = invoiceNumber.replace(/^TAGITS/, 'TAGITSTORE').replace(/\//g, '-');
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${formattedInvoiceNumber}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => {
                console.error('Error downloading the PDF:', error);
            });
    };
    const columns = [
        {
            field: 'sno_id',
            headerName: 'S.No',
            width: 100,
            headerAlign: 'left',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return <span>{params.value}</span>;
            }
        },
        {
            field: 'productName',
            headerName: 'Product Name',
            width: 150,
            headerAlign: 'left',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return <span>{params.value}</span>;
            }
        },
        {
            field: 'businessName',
            headerName: 'Business Name',
            width: 150,
            headerAlign: 'left',
            align: 'center',
            sortable: false,
            renderCell: (params) => {
                return <span>{params.value}</span>;
            },
            disableColumnMenu: true
        },
        {
            field: 'businessId',
            headerName: 'Business Subscription ID',
            width: 150,
            headerAlign: 'left',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    <Link
                        component='button'
                        variant='body2'
                        onClick={() =>
                            params.row.status === 'expired' ? handleOpenDialog(params.row) : handleConfig(params.row)
                        }
                    >
                        {params.value}
                    </Link>
                );
            }
        },
        {
            field: 'subscriptionPlan',
            headerName: 'Subscription Plan',
            width: 200,
            headerAlign: 'left',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return <span>{params.value}</span>;
            }
        },
        {
            field: 'subscriptionType',
            headerName: 'Subscription Type',
            width: 200,
            headerAlign: 'left',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return <span>{params.value}</span>;
            }
        },
        {
            field: 'purchasedOn',
            headerName: 'Purchased On',
            width: 150,
            headerAlign: 'left',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => moment(params.row.purchasedOn).format('DD/MM/YYYY')
        },
        {
            field: 'expiry',
            headerName: 'Expiry',
            width: 150,
            headerAlign: 'left',
            align: 'center',
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => moment.utc(params.row.expiry).endOf('day').format('DD/MM/YYYY')
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            headerAlign: 'left',
            sortable: false,
            disableColumnMenu: true,
            align: 'center',
            renderCell: (params) => (
                <Chip
                    label={params.row.status.charAt(0).toUpperCase() + params.row.status.slice(1)}
                    color={params.row.status === 'Active' || params.row.status === 'active' ? 'success' : 'error'}
                    variant='outlined'
                />
            )
        },
        {
            field: 'invoice',
            headerName: 'Invoice',
            width: 150,
            sortable: false,
            disableColumnMenu: true,
            headerAlign: 'left',
            align: 'center',
            renderCell: (params) =>
                params.row.subscriptionType.toLowerCase() === 'trial' ? null : (
                    <IconButton color='primary'>
                        <DownloadIcon
                            onClick={() =>
                                handlePdf(params?.row?.cancel_id, params?.row?.invoiceNumber, params?.row?.businessName)
                            }
                        />
                    </IconButton>
                )
        },

        {
            field: isDisabled ? 'actions' : null,
            headerName: isDisabled ? 'Actions' : null,
            width: isDisabled ? 300 : 0,
            headerAlign: 'left',
            sortable: false,
            disableColumnMenu: true,
            align: 'center',
            renderCell: (params) => {
                const { expiry, is_renewed, subscriptionType, status } = params.row;

                const renewalStatus = is_renewed ? is_renewed : false;

                const expiryDate = moment.utc(expiry);
                const currentDate = moment.utc();
                const daysDifference = expiryDate.diff(currentDate, 'days');
                const isRenewEnabled =
                    !renewalStatus && daysDifference <= 15 && subscriptionType.toLowerCase() !== 'trial';

                const isCancelledAndTrial =
                    status === 'cancelled' ||
                    subscriptionType.toLowerCase() === 'trial' ||
                    (status === 'cancelled' && subscriptionType.toLowerCase() === 'trial');
                return (
                    <>
                        {params?.row?.status.toLowerCase() !== 'deleted' && (
                            <>
                                {isDisabled
                                    ? params?.row?.subscriptionType.toLowerCase() === 'trial' && (
                                          <Chip
                                              label={
                                                  params.row.subscriptionType.toLowerCase() === 'trial'
                                                      ? 'Subscribe'
                                                      : 'Upgrade'
                                              }
                                              color='primary'
                                              variant='outlined'
                                              onClick={() => handleSubscribe(params?.row)}
                                              style={{ marginRight: 8 }}
                                              disabled={params?.row?.status === 'cancelled'}
                                          />
                                      )
                                    : null}

                                {!renewalStatus && isDisabled && subscriptionType.toLowerCase() !== 'trial' ? (
                                    <Chip
                                        label='Renew'
                                        color='primary'
                                        variant='outlined'
                                        onClick={() =>
                                            handleRenew(
                                                'renew',
                                                params?.row?.busId,
                                                params?.row?.prodId,
                                                params?.row?.planId,
                                                params?.row?.productName,
                                                params?.row?.plan,
                                                params?.row?.cancel_id,
                                                params?.row?.renew,
                                                params?.row?.bid
                                            )
                                        }
                                        style={{ marginRight: 8 }}
                                        disabled={
                                            !isRenewEnabled ||
                                            subscriptionType.toLowerCase() === 'trial' ||
                                            isCancelledAndTrial ||
                                            params?.row?.status === 'cancelled'
                                        }
                                    />
                                ) : null}

                                {!params?.row?.cancelled && params?.row?.status.toLowerCase() !== 'expired'
                                    ? isDisabled && (
                                          <Chip
                                              label='Cancel'
                                              color='primary'
                                              variant='outlined'
                                              onClick={() => handleCancel(params?.row?.cancel_id)}
                                              disabled={isCancelledAndTrial}
                                          />
                                      )
                                    : null}
                            </>
                        )}
                    </>
                );
            }
        }
    ];
    const modalColumns = [
        { field: 'sno_id', headerName: 'S.No', disableColumnMenu: true },
        { field: 'productname', headerName: 'Product Name', disableColumnMenu: true },
        { field: 'businessname', headerName: 'Business Name', disableColumnMenu: true },
        { field: 'id', headerName: 'Business Subscription ID', disableColumnMenu: true },
        { field: 'plan', headerName: 'Subscription Plan', disableColumnMenu: true },
        { field: 'type', headerName: 'Subscription Type', disableColumnMenu: true },
        { field: 'purchased', headerName: 'Purchased On', disableColumnMenu: true },
        { field: 'expiry', headerName: 'Expiry', disableColumnMenu: true },

        {
            field: 'satus',
            headerName: 'Status',
            disableColumnMenu: true,
            renderCell: (params) => (
                <Chip
                    label={params.value === 'Active' ? 'Active' : 'Inactive'}
                    color={params.value === 'Active' ? 'success' : 'error'}
                    variant='outlined'
                />
            )
        },

        {
            field: 'invoice',
            headerName: 'Invoice',
            disableColumnMenu: true,
            renderCell: (params) => (
                <IconButton color='primary'>
                    <DownloadIcon />
                </IconButton>
            )
        },

        {
            field: 'actions',
            headerName: 'Actions',
            disableColumnMenu: true,
            renderCell: (params) => (
                <Chip
                    label={params.value === 'Active' ? 'Active' : 'Buy Now'}
                    color={params.value === 'Active' ? 'success' : 'error'}
                    variant='outlined'
                />
            )
        }
    ];

    const modalRows = [
        {
            id: 1,
            sno_id: 1,
            productname: 'Communication Channel Service-SMS',
            businessname: 'Glutonny',
            id: '75000BS0000923',
            plan: '1Credit/100Counts/1month',
            type: 'Add ons',
            purchased: '07/03/2025',
            expiry: 'Till count exist',
            satus: 'Active',
            invoice: '31-12-2025',
            actions: '6325412548'
        }
    ];
    return (
        <>
            <Card elevation={2}>
                <TableContainer
                    sx={{
                        overflowX: 'auto',
                        maxWidth: '100%'
                    }}
                >
                    {clientListRows?.length === 0 ? (
                        <Typography variant='h6' align='center' sx={{ padding: 2 }}>
                            No Data Found
                        </Typography>
                    ) : (
                        <CustomDatagrid
                            rows={clientListRows}
                            columns={columns}
                            getRowId={(row) => row.id}
                            paginationModel={paginationModelSub}
                            onPaginationModelChange={setPaginationModelSub}
                            rowCount={rowCountSub}
                            disableSelectionOnClick={true}
                            checkboxSelection={false}
                            pagination
                            pageSizeOptions={[5, 10, 20]}
                        />
                    )}
                </TableContainer>
            </Card>
            <PriceDetails
                open={openPriceDetailsModal}
                onClose={() => setOpenPriceDetailsModal(false)}
                planId={planId}
                filteredPlans={filteredPlans}
                setFilteredPlans={setFilteredPlans}
                renewPlan={renewPlan}
                planData={planData}
                busUUID={busUUID}
                setBusUUID={setBusUUID}
                setPlanData={setPlanData}
                setRenewPlan={setRenewPlan}
                setRenewPlanOff={setRenewPlanOff}
                renewPlanOff={renewPlanOff}
                subUUID={subUUID}
                setSubUUID={setSubUUID}
                setProductDetails={setProductDetails}
                productDetails={productDetails}
                selectedPlanDetails={selectedPlanDetails}
                setSelectedPlanDetails={setSelectedPlanDetails}
            />
            <Dialog open={openSubscribeDialog}>
                <DialogTitle>Confirm Subscription</DialogTitle>
                <DialogContent>
                    <Typography>
                        You have existing entries from your trial period. Do you want to continue your subscription
                        along with your existing data?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleYes} color='primary'>
                        Yes
                    </Button>
                    <Button onClick={handleNo} color='primary'>
                        No
                    </Button>
                    <Button onClick={handleDialogClose} color='primary'>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openDialog} onClose={() => {}} disableBackdropClick>
                <DialogTitle>
                    Subscription Expired
                    <IconButton
                        aria-label='close'
                        onClick={handleCloseDialog}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>Subscription expired. Kindly renew it.</DialogContent>
                <DialogActions>
                    <Button
                        onClick={() =>
                            handleRenew(
                                'renew',
                                renewData?.busId,
                                renewData?.prodId,
                                renewData?.planId,
                                renewData?.productName,
                                renewData?.plan,
                                renewData?.cancel_id,
                                renewData?.renew,
                                renewData?.bid
                            )
                        }
                        color='primary'
                        variant='contained'
                    >
                        Renew
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default OrdersList;
